import {z} from 'zod';

export const GetSvCloudBookingUrlApiArgSchema = z.object({
  branchId: z.string(),
  resourceCode: z.string(),
  resourceId: z.string(),
});
export type GetSvCloudBookingUrlApiArg = z.infer<typeof GetSvCloudBookingUrlApiArgSchema>;

export const SvCloudBookingUrlResponseBodySchema = z.object({
  bookingUrl: z.string().nullable(),
});
export type SvCloudBookingUrlResponseBody = z.infer<typeof SvCloudBookingUrlResponseBodySchema>;

export type GetSvCloudBookingUrlApiResponse = SvCloudBookingUrlResponseBody;
